export default __webpack_public_path__ + "static/media/Green Circle.2dae3ede.svg";